import { gql } from '@apollo/client';

export const DOWNLOAD_SHOPIFY_CUSTOMERS = gql`
  mutation DownloadShopifyCustomers {
    downloadShopifyCustomers {
      errors { path, message }
    }
  }
`;
